"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _polished = require("polished");

var _styled = _interopRequireDefault(require("../styled"));

var _InteractionRipples = _interopRequireDefault(require("./InteractionRipples"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styled["default"].button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  outline: none;\n  background-color: transparent;\n  cursor: pointer;\n  line-height: 0;\n\n  padding: 12px;\n  margin: 3px;\n  border: none;\n\n  border-radius: 50%;\n  vertical-align: middle;\n\n  color: ", ";\n\n  @media (hover: hover) {\n    &:hover {\n      background-color: ", ";\n    }\n  }\n\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  &:-moz-focusring {\n    outline: none;\n  }\n\n  svg {\n    width: 1.5rem;\n\n    path {\n      fill: currentColor;\n    }\n  }\n"])), function (props) {
  return props.color || props.theme.foreground;
}, function (props) {
  return (0, _polished.transparentize)(0.9, props.color || props.theme.foreground);
});
/**
 * Accepts mostly the same props as the `Button` component.
 *
 * While you can theoretically pass anything into as children to the Button, in practice you should only ever pass in an `<Icon />`
 * from `@mdi/react` in combination with icons from `@mdi/js` (see examples below) because of sizing concerns, or stick to the conventions
 * these two libraries use when making custom icons.
 */


var IconButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var disabled = _ref.disabled,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["disabled", "children"]);

  return /*#__PURE__*/React.createElement(Wrapper, _extends({}, rest, {
    ref: ref,
    tabIndex: -1,
    disabled: disabled
  }), /*#__PURE__*/React.createElement(_InteractionRipples["default"], {
    offset: 12,
    focusable: true,
    centered: true,
    disabled: disabled
  }), children);
});
var _default = IconButton;
exports["default"] = _default;